<template>
  <div class="p-8 bg-neutral-300">
    <div class="w-full flex items-center justify-center" v-if="loading">
      <Lynx-Spinner size="16" />
    </div>
    <div class="flex flex-col" v-else>
      <div class="flex justify-between items-center">
        <Lynx-Title
          :text="`${viabilidade.cidade.nome} - ${viabilidade.cidade.estado.uf}`"
        />
        <Lynx-Button
          class="mb-8"
          @click.native="onCancelEdit"
          text="Cancelar"
          size="small"
          :outlined="true"
          v-if="isEditting"
        />
        <Lynx-Button
          class="mb-8"
          @click.native="onEdit"
          text="Editar"
          icon="Edit"
          size="small"
          icon-size="4"
          v-else-if="$hasPermission('editar viabilidade')"
        />
      </div>
      <div class="flex items-center pb-8">
        <span class="pr-4 font-bold text-primary-600">Ultima atualização:</span>
        <span
          class="py-1 px-2 text-neutral-100 text-xs rounded"
          :class="
            getUpdatedAtTheme(getUpdatedAtDifference(viabilidade.updated_at))
          "
        >
          {{ getUpdatedAtDifference(viabilidade.updated_at) | mes }}
        </span>
      </div>
      <form class="flex flex-col" @submit.prevent="onSubmit">
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Emitem alvará para empresa médica com o endereço fiscal?"
            />
            <b-checkbox
              class="pl-8"
              v-model="form.alvara_endereco_fiscal"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{
              viabilidade.alvara_endereco_fiscal | boolean
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="CNAE especifico exigido pelo município"
            />
            <Lynx-Input
              v-model="form.cnae_exigido"
              v-if="isEditting"
              placeholder="(Opcional)"
            />
            <span v-else>{{ viabilidade.cnae_exigido | text }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Há restrição do CNAE pelo município?"
            />
            <Lynx-Input
              v-model="form.cnae_restricao"
              v-if="isEditting"
              placeholder="(Opcional)"
            />
            <span v-else>{{ viabilidade.cnae_restricao | text }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Precisa de vigilancia?" />
            <b-checkbox
              class="pl-8"
              v-model="form.vigilancia"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{
              viabilidade.vigilancia | boolean
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label class="pr-8 font-bold" label="Modelo de Solicitação" />
            <b-select
              v-model="form.modelo_solicitacao"
              v-if="isEditting"
              required
            >
              <option value="presencial">Presencial</option>
              <option value="email">Email</option>
              <option value="site">Site</option>
            </b-select>
            <span
              class="capitalize"
              v-text="viabilidade.modelo_solicitacao"
              v-else
            />
          </label>
        </div>
        <div
          class="flex flex-col pb-8"
          v-if="
            viabilidade.modelo_solicitacao_site ||
            (isEditting && form.modelo_solicitacao === 'site')
          "
        >
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Site Modelo Solicitação"
            />
            <Lynx-Input
              v-model="form.modelo_solicitacao_site"
              v-if="isEditting"
              type="url"
            />
            <a
              class="underline text-primary-600"
              :href="viabilidade.modelo_solicitacao_site"
              v-text="viabilidade.modelo_solicitacao_site"
              target="_blank"
              v-else
            />
          </label>
        </div>
        <div
          class="flex flex-col pb-8"
          v-if="
            viabilidade.modelo_solicitacao_email ||
            (isEditting && form.modelo_solicitacao === 'email')
          "
        >
          <label class="flex flex-col">
            <Lynx-Label class="pr-8 font-bold" label="Email para Solicitação" />
            <Lynx-Input
              v-model="form.modelo_solicitacao_email"
              v-if="isEditting"
              type="email"
            />
            <span
              v-text="viabilidade.modelo_solicitacao_email"
              target="_blank"
              v-else
            />
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Tempo para emissão do alvará"
            />
            <div class="pl-8 flex items-center">
              <Lynx-Input
                class="ml-8 mr-2"
                v-model="form.mes_renovacao_alvara"
                v-if="isEditting"
                type="number"
                required
              />
              <span v-text="viabilidade.mes_renovacao_alvara" v-else />
              <span class="pl-2">mes</span>
            </div>
          </label>
        </div>
        <div
          class="flex flex-col pb-8"
          v-if="
            viabilidade.modelo_renovacao_site ||
            (isEditting && form.modelo_renovacao === 'site')
          "
        >
          <label class="flex flex-col">
            <Lynx-Label class="pr-8 font-bold" label="Site Modelo Renovação" />
            <Lynx-Input
              v-model="form.modelo_renovacao_site"
              v-if="isEditting"
              type="url"
            />
            <a
              class="underline text-primary-600"
              :href="viabilidade.modelo_renovacao_site"
              v-text="viabilidade.modelo_renovacao_site"
              target="_blank"
              v-else
            />
          </label>
        </div>
        <div
          class="flex flex-col pb-8"
          v-if="
            viabilidade.modelo_renovacao_email ||
            (isEditting && form.modelo_renovacao === 'email')
          "
        >
          <label class="flex flex-col">
            <Lynx-Label class="pr-8 font-bold" label="Email para Solicitação" />
            <Lynx-Input
              v-model="form.modelo_renovacao_email"
              v-if="isEditting"
              type="email"
            />
            <span
              v-text="viabilidade.modelo_solicitacao_email"
              target="_blank"
              v-else
            />
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Tempo para emissão do alvará"
            />
            <div class="pl-8 flex items-center">
              <Lynx-Input
                class="ml-8 mr-2"
                v-model="form.tempo_emissao_alvara"
                v-if="isEditting"
                type="number"
                required
              />
              <span v-text="viabilidade.tempo_emissao_alvara" v-else />
              <span class="pl-2">dias</span>
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Tempo para emissão da licença sanitária"
            />
            <div class="pl-8 flex items-center">
              <Lynx-Input
                class="ml-8 mr-2"
                v-model="form.tempo_emissao_licenca_sanitaria"
                v-if="isEditting"
                type="number"
              />
              <span v-else>
                {{ viabilidade.tempo_emissao_licenca_sanitaria | text }}</span
              >
              <span class="pl-2">dias</span>
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Valor do alvará" />
            <div class="pl-8 flex items-center">
              <Input-Money
                class="ml-8 mr-2"
                v-model="form.valor_alvara"
                v-if="isEditting"
                required
              />
              <span v-else> {{ viabilidade.valor_alvara | money }}</span>
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Mês de Renovação do Alvará"
            />
            <b-select
              placeholder="Selecione o mês de renovação"
              v-model="form.mes_renovacao_alvara"
              v-if="isEditting"
            >
              <option
                v-for="(month, index) in monthNames"
                :key="month.id"
                v-text="month"
                :value="index + 1"
              />
            </b-select>
            <span v-else>{{
              monthNames[viabilidade.mes_renovacao_alvara - 1]
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Valor da licença sanitária"
            />
            <div class="pl-8 flex items-center">
              <Input-Money
                class="ml-8 mr-2"
                v-model="form.valor_licenca_sanitaria"
                v-if="isEditting"
                required
              />
              <span v-else>
                {{
                  viabilidade.valor_licenca_sanitaria !== null
                    ? `R$${viabilidade.valor_licenca_sanitaria.replace(
                        ".",
                        ","
                      )}`
                    : "-"
                }}</span
              >
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Valor do Bombeiro" />
            <div class="pl-8 flex items-center">
              <Input-Money
                class="ml-8 mr-2"
                v-model="form.valor_bombeiro"
                v-if="isEditting"
              />
              <span v-else>
                {{
                  viabilidade.valor_bombeiro !== null
                    ? `R$${viabilidade.valor_bombeiro.replace(".", ",")}`
                    : "-"
                }}</span
              >
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Valor de Coworking" />
            <div class="pl-8 flex items-center">
              <Input-Money
                class="ml-8 mr-2"
                v-model="form.valor_coworking"
                v-if="isEditting"
              />
              <span v-else>
                {{
                  viabilidade.valor_coworking !== null
                    ? `R$${viabilidade.valor_coworking.replace(".", ",")}`
                    : "-"
                }}</span
              >
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Percentual do ISS" />
            <div class="pl-8 flex items-center">
              <Lynx-Input
                class="ml-8 mr-2"
                v-model="form.percentual_iss"
                v-if="isEditting"
                type="number"
                :min="0"
                step="any"
                :max="100"
                required
              />
              <span v-else> {{ viabilidade.percentual_iss }}%</span>
            </div>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Forma de emissão da NFS"
            />
            <b-select
              v-model="form.nfs_eletronica_manual"
              v-if="isEditting"
              required
            >
              <option value="eletronica">Eletronica</option>
              <option value="manual">Manual</option>
            </b-select>
            <span
              class="capitalize"
              v-text="viabilidade.nfs_eletronica_manual"
              v-else
            />
          </label>
        </div>
        <div
          class="flex flex-col pb-8"
          v-if="
            viabilidade.nfs_eletronica_manual_site ||
            (isEditting && form.nfs_eletronica_manual === 'eletronica')
          "
        >
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Site Modelo Solicitação"
            />
            <Lynx-Input
              v-model="form.nfs_eletronica_manual_site"
              v-if="isEditting"
              type="url"
            />
            <a
              class="underline text-primary-600"
              :href="viabilidade.nfs_eletronica_manual_site"
              v-text="viabilidade.nfs_eletronica_manual_site"
              target="_blank"
              v-else
            />
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Precisa de CRM Juridico?"
            />
            <b-checkbox
              class="pl-8"
              v-model="form.crm_juridico"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{
              viabilidade.crm_juridico | boolean
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Precisa entregar DMS?" />
            <b-checkbox
              class="pl-8"
              v-model="form.dms_entrega"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{
              viabilidade.dms_entrega | boolean
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <label class="flex justify-between items-center">
              <Lynx-Label class="pr-8 font-bold" label="Não se aplica DEISS?" />
              <b-checkbox
                class="pl-8"
                v-model="naoseaplica"
                v-if="isEditting"
                :true-value="40"
                :false-value="0"
              />
              <span v-else> {{ naoseaplica | boolean }}</span>
            </label>
          </label>
        </div>

        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label class="pr-8 font-bold" label="Tem DEISS?" />
            <b-checkbox
              class="pl-8"
              v-model="temdeiss"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{ temdeiss | boolean }}</span>
          </label>
          <label class="flex">
            <Lynx-Input
              v-model="form.deiss_vencimento"
              v-if="isEditting && temdeiss"
              type="number"
            />
            <span v-else-if="temdeiss">
              Dia de vencimento: {{ viabilidade.deiss_vencimento }}</span
            >
          </label>
        </div>

        <v-card
          v-if="viabilidade.taxas || isEditting"
          elevation="4"
          class="p-3 mb-2"
        >
          <Lynx-Label class="font-bold" label="Taxas que se aplicam" />

          <div v-if="isEditting" class="flex flex-col pb-6">
            <Treeselect
              :multiple="true"
              :options="lista_taxas"
              placeholder="Selecione as taxas que se aplicam"
              v-model="taxas"
            />
          </div>

          <div v-for="(taxa, key) in lista_taxas" :key="key">
            <div
              v-if="isEditting && taxas.includes(taxa.id)"
              class="flex flex-col"
            >
              <label
                v-if="
                  form.taxas[taxa.id].tipo_cobranca != 'trimestral_recorrente'
                "
                class="flex flex-col pt-3 font-semibold"
              >
                <Lynx-Label :label="'Vencimento ' + taxa.label" />

                <Lynx-Input v-model="form.taxas[taxa.id].valor" type="date" />
              </label>
              <div v-else class="flex flex-col">
                <Lynx-Label :label="'Vencimento ' + taxa.label" />
                <Lynx-Input v-model="form.taxas[taxa.id].valor" type="date" />

                <Lynx-Label :label="'Vencimento ' + taxa.label" />
                <Lynx-Input v-model="form.taxas[taxa.id].valor1" type="date" />
                <Lynx-Label :label="'Vencimento ' + taxa.label" />
                <Lynx-Input v-model="form.taxas[taxa.id].valor2" type="date" />
              </div>

              <label class="flex flex-col pt-2 font-semibold pt-4">
                <Lynx-Label :label="'Observação ' + taxa.label" />
                <Lynx-Input
                  v-model="form.taxas[taxa.id].observacao"
                  type="text"
                />
              </label>

              <label class="flex flex-col pt-4 font-semibold">
                <Lynx-Label label="Tipo de Taxa" />

                <b-select
                  class="font-normal"
                  v-model="form.taxas[taxa.id].tipo_taxa"
                  placeholder="selecione uma taxa"
                >
                  <option
                    v-for="status in taxasOptions"
                    :key="status.id"
                    :value="status.value"
                    v-text="status.label"
                  ></option>
                </b-select>
              </label>
              <span class="text-small font-semibold pt-6">Informe o tipo:</span>
              <div class="flex flex-wrap gap-3 pb-6">
                <div class="flex items-center w-1/1">
                  <span class="mr-2">Mensal</span>
                  <b-checkbox
                    class="pl-1"
                    v-model="form.taxas[taxa.id].tipo_cobranca"
                    v-if="isEditting"
                    :true-value="'mensal'"
                    :false-value="'anual'"
                  />
                </div>
                <div class="flex items-center w-1/3">
                  <span class="mr-2">Trimestral</span>
                  <b-checkbox
                    class="pl-1"
                    v-model="form.taxas[taxa.id].tipo_cobranca"
                    v-if="isEditting"
                    :true-value="'trimestral'"
                    :false-value="form.taxas[taxa.id].tipo_cobranca"
                  />
                </div>
                <div class="flex items-center w-1/3">
                  <span class="mr-1">Trimestral Recorrente</span>
                  <b-checkbox
                    class="pl-1"
                    v-model="form.taxas[taxa.id].tipo_cobranca"
                    v-if="isEditting"
                    :true-value="'trimestral_recorrente'"
                    :false-value="form.taxas[taxa.id].tipo_cobranca"
                  />
                </div>
                <div class="flex items-center w-1/1">
                  <span class="mr-1">Semestral</span>
                  <b-checkbox
                    class="pl-1"
                    v-model="form.taxas[taxa.id].tipo_cobranca"
                    v-if="isEditting"
                    :true-value="'semestral'"
                    :false-value="form.taxas[taxa.id].tipo_cobranca"
                  />
                </div>
                <div class="flex items-center w-1/2">
                  <span class="mr-2">Anual</span>
                  <b-checkbox
                    class="pl-1"
                    v-model="form.taxas[taxa.id].tipo_cobranca"
                    v-if="isEditting"
                    :true-value="'anual'"
                    :false-value="form.taxas[taxa.id].tipo_cobranca"
                  />
                </div>
              </div>
              <hr style="border: 2px black solid" class="mt-2 mb-2" />
            </div>

            <label v-else-if="taxas.includes(taxa.id)">
              <span class="font-bold"> {{ taxa.label }}</span>
              <br />

              <span class="font-bold">{{
                viabilidade.taxas[taxa.id].tipo_cobranca !=
                "trimestral_recorrente"
                  ? "Vencimento:"
                  : "Primeiro vencimento"
              }}</span>
              {{ formatEnToBr(viabilidade.taxas[taxa.id].valor) }}
              <div
                v-if="
                  viabilidade.taxas[taxa.id].tipo_cobranca ==
                  'trimestral_recorrente'
                "
              >
                <span class="font-bold">{{ "Segundo vencimento:" }}</span>
                {{ formatEnToBr(viabilidade.taxas[taxa.id].valor1) }}
                <br />
                <span class="font-bold">{{ "Terceito vencimento:" }}</span>
                {{ formatEnToBr(viabilidade.taxas[taxa.id].valor2) }}
              </div>
              <br v-else />

              <span class="font-bold">{{ "Observação:" }}</span>
              {{ viabilidade.taxas[taxa.id].observacao }}
              <br />
              <span class="font-bold">{{ "Tipo de Cobrança:" }}</span>
              {{
                lista_tipo_cobrancas.find(
                  (item) => item.id == viabilidade.taxas[taxa.id].tipo_cobranca
                ).label
              }}
              <br />
              <span class="font-bold">{{ "Tipo de taxa:" }}</span>

              <span v-if="viabilidade.taxas[taxa.id].tipo_taxa"
                >{{
                  taxasOptions.find(
                    (item) => item.value == viabilidade.taxas[taxa.id].tipo_taxa
                  ).label
                }}
              </span>
              <span v-else class="bg-error-base rounded-full p-1">
                Sem tipo da taxa
              </span>
              <hr style="border: 2px black solid" class="mt-1 mb-5" />
            </label>
          </div>
        </v-card>
        <div
          class="flex flex-col pb-8 pt-8"
          v-if="viabilidade.documentos_necessarios.length || isEditting"
        >
          <div class="flex flex-col pb-8 pt-8">
            <Lynx-Label class="pr-8 font-bold" label="Documentos Necessários" />
            <b-taginput
              v-model="form.documentos_necessarios"
              :data="documentosNecessarios"
              v-if="isEditting"
              autocomplete
              :allow-new="true"
              :allow-duplicates="false"
              :open-on-focus="true"
              :loading="loadingDocumentos"
            />
            <ul class="flex flex-col list-disc pl-4" v-else>
              <li
                v-for="documento in viabilidade.documentos_necessarios"
                class="pb-1"
                :key="documento.id"
                v-text="documento"
              />
            </ul>
          </div>
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex justify-between items-center">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Faz abertura na área rural?"
            />
            <b-checkbox
              class="pl-8"
              v-model="form.abertura_area_rural"
              v-if="isEditting"
              :true-value="1"
              :false-value="0"
            />
            <span class="pl-8" v-else>{{
              viabilidade.abertura_area_rural | boolean
            }}</span>
          </label>
        </div>
        <div class="flex flex-col pb-8" v-if="viabilidade.arquivos.length">
          <label class="flex flex-col">
            <Lynx-Label class="pr-8 font-bold" label="Anexos" />
            <div class="grid grid-cols-2 row-gap-4 col-gap-8">
              <Anexo
                v-for="(anexo, index) in viabilidade.arquivos"
                :key="anexo.id"
                :anexo="anexo"
                :is-deletabled="isEditting"
                @remove-anexo="deleteAnexo(index)"
              />
            </div>
          </label>
        </div>
        <Lynx-Button
          class="self-start mb-8"
          text="Adicionar Anexo"
          @click.native="addAnexo"
          icon="Attachment"
          size="small"
          icon-size="4"
          :outlined="true"
          type="button"
          v-if="isEditting"
        />
        <div
          class="flex pb-8 items-end relative"
          v-for="(anexo, index) in form.anexos"
          :key="anexo.id"
        >
          <a
            href="#"
            class="p-1 bg-error-light transition hover:bg-error-base rounded-full absolute right-0 top-0"
            @click.prevent="removeAnexo(index)"
          >
            <Icon-Cross size="3" class="text-neutral-100" />
          </a>
          <label class="flex flex-col flex-grow pr-8">
            <Lynx-Label class="pr-8 font-bold" label="Nome do anexo" />
            <Lynx-Input
              v-model="anexo.nome"
              placeholder="Digite o nome do anexo"
              required
            />
          </label>
          <Input-File text="Anexo" ref="anexosInput" />
        </div>
        <div class="flex flex-col pb-8">
          <label class="flex flex-col">
            <Lynx-Label
              class="pr-8 font-bold"
              label="Observações e/ou mais informações"
            />
            <div class="bg-white" v-if="isEditting">
              <vue-editor v-model="form.observacoes"></vue-editor>
            </div>
            <div
              v-else
              v-html="viabilidade.observacoes"
              class="bg-white rounded p-4 prose"
            ></div>
          </label>
        </div>
        <Lynx-Button
          type="submit"
          class="self-end"
          text="Enviar"
          icon="Check"
          v-if="isEditting"
          :loading="loadingButton"
        />
      </form>
    </div>
  </div>
</template>

<script>
import {
  showViabilidadeMunicipalRequest,
  updateViabilidadeMunicipalRequest,
  getViabilidadeDocumentosBaseRequest,
} from "@/services/requests/viabilidadeMunicipal";
import InputMoney from "@/components/helpers/InputMoney";
import { monthNames, dayNames } from "@/utils/utils";
import Anexo from "@/views/service-order/components/Anexo";
import InputFile from "@/components/helpers/InputFile";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { TipoTaxasEnum } from "@/utils/enum";
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "ViabilidadeMunicipalView",
  components: { InputMoney, Anexo, InputFile, VueEditor, Treeselect },
  props: {
    viabilidadeId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      loadingButton: false,
      loadingDocumentos: false,
      viabilidade: {},
      isEditting: false,
      temdeiss: 0,
      monthNames,
      dayNames,
      documentosNecessarios: [],
      form: {},
      errorMessage: "Não foi possivel editar a viabilidade",
      naoseaplica: 0,
      taxas: [],
      taxasOptions: TipoTaxasEnum,
      lista_taxas: [
        {
          id: "alvara",
          label: "Alvara",
        },
        {
          id: "sanitario",
          label: "Sanitario",
        },
        {
          id: "bombeiro",
          label: "Bombeiro",
        },
        {
          id: "ambiental",
          label: "Ambiental",
        },
      ],

      lista_tipo_cobrancas: [
        {
          id: "mensal",
          label: "Mensal",
        },
        {
          id: "trimestral",
          label: "Trimestral",
        },
        {
          id: "trimestral_recorrente",
          label: "Trimestral recorrente",
        },
        {
          id: "semestral",
          label: "Semestral",
        },
        {
          id: "anual",
          label: "Anual",
        },
      ],
    };
  },
  filters: {
    money(val) {
      return val ? "R$ " + val.replace(".", ",") : "R$ 0,00";
    },
    boolean(val) {
      return val ? "Sim" : "Não";
    },
    text(val) {
      return val || "-";
    },
    mes(val) {
      return val === 1 ? `${val} mês atras` : `${val} meses atras`;
    },
  },
  watch: {
    naoseaplica: function (val) {
      this.form.deiss_vencimento = val;
      this.temdeiss = val == 40 ? 0 : 1;
    },
    temdeiss: function (val) {
      this.naoseaplica = val == 1 ? 0 : 40;
      this.form.deiss_vencimento = this.naoseaplica == 40 ? 40 : 0;
    },
    taxas: function (val) {
      const updatedTaxas = {};
      val.forEach((taxa) => {
        updatedTaxas[taxa] = {
          valor: this.viabilidade.taxas?.[taxa]?.valor || null,
          valor1: this.viabilidade.taxas?.[taxa]?.valor1 || null,
          valor2: this.viabilidade.taxas?.[taxa]?.valor2 || null,
          observacao: this.viabilidade.taxas?.[taxa]?.observacao || "",
          tipo_cobranca:
            this.viabilidade.taxas?.[taxa]?.tipo_cobranca || "mensal",
          tipo_taxa: this.viabilidade.taxas?.[taxa]?.tipo_taxa || null,
        };
      });
      this.form.taxas = updatedTaxas;
    },
  },
  methods: {
    async fetchViabilidade() {
      this.loading = true;
      await showViabilidadeMunicipalRequest(this.viabilidadeId)
        .then((res) => (this.viabilidade = res.data))
        .finally(() => (this.loading = false));
      this.temdeiss = this.viabilidade.deiss_vencimento == 40 ? 0 : 1;
      this.naoseaplica = this.viabilidade.deiss_vencimento == 40 ? 40 : 0;
      if (this.viabilidade.taxas) {
        this.taxas = Object.keys(this.viabilidade.taxas).map((taxa) => taxa);
      }
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      return momentDate !== "Invalid date" ? momentDate : "sem data";
    },
    fetchDocumentosNecessarios() {
      this.loadingDocumentos = true;
      getViabilidadeDocumentosBaseRequest()
        .then(
          (res) =>
            (this.documentosNecessarios = res.data.map((curr) => curr.name))
        )
        .finally(() => (this.loadingDocumentos = false));
    },
    getUpdatedAtDifference(val) {
      const updatedAtMonth = moment(val);
      const now = moment();
      return now.diff(updatedAtMonth, "month");
    },
    getUpdatedAtTheme(val) {
      if (val < 6) return "bg-info-base";
      if (val < 12) return "bg-warning-base";
      return "bg-error-base";
    },
    onEdit() {
      this.form = {
        ...this.viabilidade,
        anexos: [],
      };
      const updatedTaxas = {};
      if (this.form.taxas != null) {
        this.taxas.forEach((taxa) => {
          updatedTaxas[taxa] = {
            valor: this.viabilidade.taxas[taxa]?.valor || null,
            valor1: this.viabilidade.taxas[taxa]?.valor1 || null,
            valor2: this.viabilidade.taxas[taxa]?.valor2 || null,
            observacao: this.viabilidade.taxas[taxa]?.observacao || "",
            tipo_cobranca:
              this.viabilidade.taxas[taxa]?.tipo_cobranca || "mensal",
            tipo_taxa: this.viabilidade.taxas[taxa]?.tipo_taxa || null,
          };
          if (
            this.viabilidade.taxas[taxa]?.tipo_cobranca !==
            "trimestral_recorrente"
          ) {
            updatedTaxas[taxa].valor1 = null;
            updatedTaxas[taxa].valor2 = null;
          }
        });
        this.form.taxas = updatedTaxas;
      }

      this.isEditting = true;
    },
    onCancelEdit() {
      this.form = {};
      this.isEditting = false;
    },
    async onSubmit() {
      if (this.form.anexos.length) {
        const hasNoFiles = this.$refs.anexosInput.filter((curr) => !curr.file);
        if (hasNoFiles.length)
          return this.$snack.error("Insira todos os arquivos dos anexos");
        const promises = this.$refs.anexosInput.map(async (curr, index) => {
          const fileId = await curr.submit();
          this.form.anexos[index].arquivo_id = fileId;
        });
        await Promise.all(promises);
      }
      this.loadingButton = true;
      let form = {
        ...this.form,
        modelo_solicitacao_site:
          this.form.modelo_solicitacao === "site"
            ? this.form.modelo_solicitacao_site
            : "",
      };

      await updateViabilidadeMunicipalRequest(this.viabilidade.id, form)
        .then(() => {
          this.$emit("edit-viabilidade");
          this.$snack.success("Viabilidade atualizada com sucesso");
        })
        .catch((err) =>
          this.$snack.error(err.response.data.message || this.errorMessage)
        )
        .finally(() => (this.loadingButton = false));
    },
    addAnexo() {
      const newAnexo = {
        nome: "",
        arquivo_id: null,
      };
      this.form.anexos.push(newAnexo);
    },
    removeAnexo(index) {
      this.form.anexos.splice(index, 1);
    },
    deleteAnexo(index) {
      this.viabilidade.arquivos.splice(index, 1);
    },
  },
  beforeMount() {
    this.fetchViabilidade();
    this.fetchDocumentosNecessarios();
  },
};
</script>
